module.exports = __webpack_public_path__ + "resources/img/bg_banner_support.b6282bac6c55b886a163c3db644bb9d7.png";